import { type Actions, Helpers, thunk } from "easy-peasy";

import { batcher } from "../../dependencies/utils";

export default function batchedThunk<
  Model extends object,
  Payload = undefined,
  Injections = void,
>(
  processBatch: (
    actions: Actions<Model>,
    payloads: Payload[],
    helpers: Helpers<Model, Model, Injections>,
  ) => void,
  period: number,
) {
  // this feels like a hacky way to pass `actions` and `helpers` references to the `processBatch` function, there might be a better way to structure this function
  let _actions: Actions<Model>;
  let _helpers: Helpers<Model, Model, Injections>;

  const addToBatch = batcher<Payload>(
    (currentBatch) => processBatch(_actions, currentBatch, _helpers),
    period,
  );

  return thunk<Model, Payload, Injections, Model, void>(
    (actions, payload, helpers) => {
      _actions = actions;
      _helpers = helpers;
      addToBatch(payload);
    },
  );
}
